// extracted by mini-css-extract-plugin
module.exports = {"banner":"PageBanner-module--banner--3vVnQ"};